import { refreshCurrentSession as refreshCurrentSessionAW } from 'aw-package-react-authentication';
import { Logger } from 'ia-react-core';
import { Location } from 'react-router-dom';
import { Company } from '~/interfaces/CompanyConfig';
import { getCompanyByPath, getCompanyTenant } from '~/utils/companyUtils';

export const refreshCurrentSession = (isAuthenticated: boolean, logger: Logger, location: Location) => {
  if (isAuthenticated) {
    if (process.env.REACT_APP_API_GATEWAY_MOCK === 'true') return;

    const company = getCompanyByPath(location.pathname);
    const tenant = getCompanyTenant(company);

    const languageMap: Record<string, string> = {
      [Company.IAGP]: 'fr',
      [Company.IAPW]: 'en',
    };

    const lang = languageMap[company];
    const args = lang ? [tenant, lang] : [tenant];

    refreshCurrentSessionAW(...args)
      .catch((error: unknown) => logger.error(error));
  }
};
